module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fdnI7A/tc-custom/9781682303580.jpg?1736916379880",
      "alt": "This image is the cover for the book Lucky Stars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lucky Stars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A meddling mom follows her daughter to Hollywood in a novel by the "), _c('i', [_vm._v("New York Times")]), _vm._v("-bestselling author: ")]), _c('b', [_vm._v("“Wildly inventive…quite funny and always engaging.” —"), _c('i', [_vm._v("People")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Stacey left Cleveland for the glamour of Hollywood, intent on becoming a star. Another bonus of heading west was putting some distance between herself and her smotheringly overprotective mom, Helen. Of course, it can’t stop Helen from buzzing her cellphone every twenty minutes."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Now her mother has trekked all the way to Tinseltown to be with Stacey—and moved in right down the street. But the twist of the knife really comes when Helen complains about finding a bone in her can of tuna, and winds up getting an apology from the company—and an offer to star in a high-profile commercial that not only leads to an unexpected acting career but lands her a mysterious dreamboat."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Meanwhile, Stacey's own career is starting to tank and she's falling for a man she thought she hated. Her resentment of her mom is more than she can bear—but she may become the protective one when she learns something shady about Helen’s new boyfriend…"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Spirited, effortless entertainment with a winning premise.” —"), _c('i', [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Heller\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0